

import React, { Component } from 'react';
import Select from 'react-select';
import Datetime from 'react-datetime';
import ReactDOM from "react-dom";
import Modal from 'react-responsive-modal';
import Datepicker from '../layouts/datepicker.js';
import { AgGridReact } from '@ag-grid-community/react';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import 'react-datetime/css/react-datetime.css';
import redirectURL from '../redirectURL';
import { Redirect } from 'react-router-dom';
import $ from 'jquery';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
import LoadingAreaLegs from './loadingarealegs.js';
import RFQView from './rfqpreviewcomponent.js';
import Allactioncomponent from './allactioncomponent.js';
import Actionforsuperadmincomponent from './actionsforsuperadmincomponent.js';
import Allactionsuperadmincomponent from './allactionforsuperadmincomponent.js';
import BidButton from './bidbutton.js';
import AttachmentButton from './attahcmentbutton.js';
import CommentsButton from './commentsbutton.js';
import ViewRFQButton from './viewrfqdetails.js';
import CancelIndentButton from './cancelindentbtn.js';
import NotificationButton from './notificationbtn.js';
import CommentsAllButton from './commentslogscomponent.js';
import Materialcomponent from './Materialviewcomponent.js';
import ParticipantsComponent from './participantscomponent.js';
// import { useParams } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import ExportIcon from "../../assets/icons/export-arrow.svg";
import ImportIcon from "../../assets/icons/import.svg";
import Filter from '../../assets/icons/SEARCH.png'
import Filter1 from '../../assets/icons/filters.svg'
import CountdownTimer from './runningtime.js';
import CountdownTimerforbid from './countdowntimerforbid.js';
//  import io from 'socket.io-client';
import { getHyphenDDMMYYYYHHMM, getHyphenDDMMYYYYHHMMSS, getHyphenYYYYMMDDHHMM, getHyphenDDMMYYYY } from '../common/utils';
import { onNewBid, emitDataReceived } from '../socketManager';

var moment = require('moment');


const customSelectStyles = {
  option: (provided) => ({
    ...provided,
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '14px',
  }),
};

const getOptionsLabel = (options, value) => {
  for (let e of options) {
    if (e.value == value) return e.label
  }
}

const userType = localStorage.getItem("user_type");
const comments_logs_columns = [
  {
    headerName: "Indent ID",
    field: "indent_id",
    width: 120,
    resizable: true,

  },
  {
    headerName: "Action",
    field: "action",
    width: 300,
    resizable: true,

  },
  {
    headerName: "Action By",
    field: "action_by",
    resizable: true,


  },
  {
    headerName: "Action Date & Time",
    field: "action_time",
    resizable: true,

    valueFormatter: function (params) {
      if (!params.value) return '';
      return getHyphenDDMMYYYYHHMM(params.value)
    },
    cellStyle: { textTransform: 'capitalize' }
  },
  {
    headerName: "Remarks",
    field: "remarks",
    width: 200,
    resizable: true,

  },
]
const particiapants_column = [
  {
    headerName: "Indent ID",
    field: "indent_id",
    width: 160,
    filter: false,
  },
  {
    headerName: "Vendor Name",
    field: "vendor",
    width: 160,
    filter: false,
  },
  {
    headerName: "Participation Status",
    field: "status",
    filter: false,
    valueFormatter: params => {
      const status = (params.value || "").toLowerCase();
      if (status === "accepted") return "Accepted";
      if (status === "declined") return "Declined";
      if (status === "No Response") return "No Response";
      return params.value; // fallback
    },
    cellStyle: params => {
      const status = (params.value || "").toLowerCase();
      let color = 'black';

      if (status === 'accepted') {
        color = 'green';
      } else if (status === 'declined') {
        color = 'red';
      } else if (status === 'No Response') {
        color = 'blue';
      }

      return {
        color: color,
        fontWeight: 'bold',
        textTransform: 'capitalize'
      };
    }
  },
  {
    headerName: "Remarks",
    field: "remarks",
  }


]
const material_columns = [
  { headerName: "Dealer Code", field: "dealer_code", width: 150 },
  { headerName: "Dealer Name", field: "dealer_name", width: 200 },
  { headerName: "Dealer City", field: "dealer_city", width: 130 },
  { headerName: "Dealer State", field: "dealer_state", width: 160 },
  { headerName: "Dealer Pincode", field: "dealer_pincode", width: 130 },
  {
    headerName: "Material Type",
    field: "material_type",
    width: 180,
  },
  {
    headerName: "Dimensions(L x B x H)",
    valueGetter: function (params) {
      var m = params.data;
      return m.material_length + " x " + m.material_breath + " x " + m.material_height + " " + m.material_units;
    },
    width: 200,
  },
  {
    headerName: "Quantity",
    field: "quantity",
    width: 100,
  },
  {
    headerName: "Prerequisite",
    field: "basic_requirment",
    width: 180,
  }
]
class IndentAuctionComponent2 extends Component {
  constructor(props) {
    super(props);
    const today = moment().format('YYYY-MM-DD');
    const oneWeekAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');

    this.state = {
      redirect: false,
      open: false,
      selectedindent: {},
      bidDetailsform: false,
      draftdata: [],
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true
      },
      loadshow: "show-n",
      overlay: "show-n",
      isToggled: 0,
      showsweetalert: false,
      hoveredIconId: null,
      filterToggle: false,
      selectedfromdate: oneWeekAgo,
      selectedenddate: today,
      basicType: "",
      basicTitle: "",
      approval1RejectionReason: '',
      hoveredIcon: null,
      rfqform: {
        active: 'activet1',
        total: '',
        drafts: '',
        cancelled: '',
        myactivity: '',
        archieved: '',
        awarded: '',
        upcoming: '',
        selectedindentid: '',
        completed: '',
        current_bidding: 'activet',
        bidding_history: ''
      },
      biddetails: [],
      allindents: [],
      bulkUploadModal: {
        overly: "show-n",
        bulkPrioritySlide: ""
      },
      filterdata: [],
      originalindents: [],
      alldata: [],
      indentsdata: [],
      selected_bid_price: '',
      selected_transit_days: '',
      transit_time: '',
      searchfilter: {},
      isCardOpen: "",
      cardforadminbifurcation: '',
      selectedTab: "Pending",
      dataforadminbifur: [],
      rejectModel: "",
      storedTrucksModel: "",
      selectedindentforvendor: {},
      isCardOpen3: '',
      indent_for_approve: [],
      indent_for_approve_for_bid: [],
      indent_for_approve_for_bid1: [],
      indentfortruckdetails: [],
      indent_for_approve1: [],
      lr_no_data: [],
      paramsforrejection: {},
      selecteddata: {},
      showAllRecords: false,
      bidHistory: [],
      inputTextValue: "",
      inputTextQuantity: "",
      negotiations: [],
      negotiationsHistory: [],
      isProposedInputOpen: "",
      isVendorInputOpen: "",
      modelForAdditionalComments: false,
      additionalComments: '',
      vendorQuotes: [],
      modelForNotifications: false,
      notificationUnread: [],
      notificationRead: [],
      modelForEditAssigned: false,
      rejectionReason: "",
      rejectionReasonbyvendor: "",
      countersfortab: {
        activecount: 0,
        totalcount: 0,
        deliveredcount: 0,
        awardcount: 0,
        vendorrejectedcount: 0,
        vehicleplacementmissedcount: 0,
        draftscount: 0,
        rejectedcount: 0,
        expiredcount: 0
      },
      selectedIndentData: [],
      inputTextValues: {},        // { [vendor_email_id]: value }
      proposedDays: {},
      selectedVendorQuotes: [],
      isPreviewMode: false,
      rfqForm: {},
      dealers: [
        {
          dealer_code: "",
          dealer_name: "",
          dealer_city: "",
          dealer_state: "",
          dealer_pincode: "",
          materials: [
            {
              material_type: "",
              material_length: 0,
              material_breath: 0,
              material_height: 0,
              material_units: "cm",
              quantity: 0,
              basic_requirment: ''
            },
          ]
        },
      ],
      text: '',
      destinationdetails: [],
      rowData: [],

    };
  }

  componentDidMount() {
    redirectURL.post('/consignments/getrfqtrucktype').then((resp) => {
      console.log(resp.data)
      let truck_list = resp.data;
      let truck_list_arr = truck_list.map(function (e) {
        return { label: e.truck_type, value: e.truck_type };
      });

      this.setState({
        truck_list: truck_list_arr
      });
    })
    this.fetchData();

    onNewBid((data => {
      this.fetchData()
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.allindents !== this.state.allindents) {
      this.transformIndentData();
    }
  }
  componentWillUnmount() {
  }
  handleDatesSelected = (start, end) => {
    console.log(start, end)
    this.setState((prevState) => {
      let newFrom = prevState.selectedfromdate;
      let newTo = prevState.selectedenddate;

      if (start) {
        newFrom = start.format("YYYY-MM-DD");
      }
      if (end) {
        newTo = end.format("YYYY-MM-DD");
      }
      return {
        selectedfromdate: newFrom,
        selectedenddate: newTo
      };
    }, this.fetchInitialData);
  };


  refreshSelected = () => {
    const today = moment().format('YYYY-MM-DD');
    const oneWeekAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');

    this.setState({
      selectedfromdate: oneWeekAgo,
      selectedenddate: today
    });
  };
  onGridReady = (params) => {
    this.gridApi = params.api;
  }

  transformIndentData = () => {
    const transformedData = this.state.allindents.map(indent => {
      let destinationStr = '';
      let materialStr = '';

      try {
        const dest = JSON.parse(indent.destination || '[]');
        destinationStr = dest.map(d => d.dealer_city).join(', ');
        materialStr = dest.flatMap(d => d.materials || [])
          .map(m => m.material_type)
          .join(', ');
      } catch { }

      return {
        indent_id: indent.indent_id || indent.draft_id,
        status: this.getIndentStatus(indent),
        source: indent.source,
        destination: destinationStr,
        material: materialStr,
        truck_type: indent.type_of_truck === 'others' ? indent.selected_truck_type : indent.type_of_truck,
        pickup_date: getHyphenDDMMYYYY(indent.pickup_date),
        quantity: `${indent.confirmed_quantity}/${indent.quantity}`,
        confirmed_value: indent.confirmed_value || 'N/A',
        base_price: indent.base_price || '0',
        total_km: indent.total_km || '0',
        bid_start_date: getHyphenDDMMYYYYHHMM(indent.bid_start_date),
        vendor_count: (indent.vendorquotes && indent.vendorquotes.length) || 0,
        indent
      };
    });

    this.setState({ rowData: transformedData });
  }
  fetchData = () => {
    this.fetchInitialData();
  };
  getcountersforindents = (data) => {
    const indentsdata = data;
    let activedata = [];
    let approveddata = [];
    let rejecteddata = [];
    let draftdata = [];
    let pendingdata = [];

    const userType = localStorage.getItem('user_type');
    const userEmail = localStorage.getItem('email');

    // Pending Count Logic
    if (userType === 'TRANSPORTER') {
      pendingdata = indentsdata.filter(e => {
        if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
          const vendorquote = e.vendorquotes.find(quote =>
            quote.vendor_email_id === userEmail && quote.bid_winner === 1
          );
          return vendorquote !== undefined;
        }
        return false;
      });
    } else {
      pendingdata = indentsdata.filter(e =>
        e.indent_assigned !== 1 &&
        e.approvedwithapproval1 === 1 &&
        e.rejectedwithapproval2 !== 1 &&
        e.approvedwithapproval2 !== 1 &&
        e.rejected !== 1 &&
        !['Expired', 'Negotiation In Progress'].includes(this.getStatusFromIndent(e))
      );

    }

    // Approved Count
    approveddata = indentsdata.filter(e => e.approvedwithapproval2 === 1 && e.rejected !== 1);

    // Rejected Count
    rejecteddata = indentsdata.filter(e => e.rejected === 1);

    // Draft Count
    draftdata = this.state.draftdata || [];

    // Total Count = sum of pending, approved, and rejected
    const totalCount = pendingdata.length + approveddata.length + rejecteddata.length;

    this.setState({
      countersfortab: {
        totalCount,
        pendingCount: pendingdata.length,
        approvedcount: approveddata.length,
        rejectedcount: rejecteddata.length,
        draftscount: draftdata.length
      }
    });
  }

  onClickshowparticipants = async (params) => {
    if (params != 0) {

      await this.setState({
        detailCellRendererParams: {
          detailGridOptions: {

            columnDefs: particiapants_column
          },

          getDetailRowData: async function (params) {
            const indent = params && params.data && params.data.indent;

            if (this.isBiddingWindowExpired(indent.bidding_window, indent.create_date)) {
              const participation = indent.vendors_participation || {};

              for (let vendorEmail of indent.vendors || []) {
                const normalizedEmail = vendorEmail.trim().toLowerCase();
                const hasNotQuoted = !indent.vendorquotes.some(
                  q => q.vendor_email_id.trim().toLowerCase() === normalizedEmail
                );

                if (hasNotQuoted && !participation.hasOwnProperty(normalizedEmail)) {
                  participation[normalizedEmail] = "No Response";
                }
              }
              indent.vendors_participation = participation;
            }

            const participation = indent && indent.vendors_participation;
            const declinedReasons = indent && indent.vendors_declined_reason || {};
            const rowData = [];
            const addedVendors = new Set(); // Track already added vendor names or emails

            if (participation) {
              for (const email in participation) {
                const status = participation[email];
                const matchedVendor = indent.vendordetails.find(e => e.email === email);
                const vendorName = matchedVendor && matchedVendor.firstname ? matchedVendor.firstname : email;

                const uniqueKey = vendorName.toLowerCase(); // Or use email.toLowerCase()

                // ✅ Skip if already added
                if (addedVendors.has(uniqueKey)) continue;

                let remarks = "";
                if (status.toLowerCase() === "declined") {
                  remarks = declinedReasons[email] || "";
                }

                rowData.push({
                  vendor: vendorName,
                  email: email,
                  status: status,
                  remarks: remarks,
                  indent_id: indent.indent_id,
                  indent: indent
                });

                addedVendors.add(uniqueKey); // Mark as added
              }
            }
            params.successCallback(rowData);
          }.bind(this),



          masterDetail: true
        }
      });

    }
    if (params.column.colDef.field == 'vendor_count') {
      params.node.setExpanded(!params.node.expanded);
    }
    else {

      params.node.setExpanded(false);
    }
  }

  getOptionsLabel = (optionsArray, value) => {
    const match = optionsArray.find(opt => opt.value === value);
    return match ? match.label : value;
  };

  acceptindent = (params) => {
    const e = params && params.data && params.data.indent;

    if (e.changed_l2_as_l1 === 1) {
      const params = e;

      redirectURL
        .post("/consignments/approvedsuperadminforl2asl1", params)
        .then((response) => {
          this.setState({
            showsweetalert: true,
            basicType: "success",
            basicTitle: `Indent ${e.indent_id} has been approved`,
            showBidDetailsSlider: false,
            overlay: "show-n"
          });
          this.resetindent();
        })
        .catch((err) => {
        });

    } else {
      const params = {
        indent_id: e.indent_id,
        vendor_email_id: e.accepted_vendor
      };

      redirectURL
        .post("/consignments/AcceptfinalQuotation", params)
        .catch((err) => {
        });

      redirectURL
        .post("/consignments/approvedindentwithsuperadmin", params)
        .then((response) => {
          this.setState({
            showsweetalert: true,
            basicType: "success",
            basicTitle: `Indent ${e.indent_id} has been approved`,
            showBidDetailsSlider: false,
            overlay: "show-n"
          });
          this.resetindent();
        })
        .catch((err) => {
        });
    }
  };

  rejectindent = (params) => {
    const e = params && params.data && params.data.indent;
    this.setState({ rejectModel: true });

    const rejectionParams = {
      indent_id: e.indent_id,
      vendor_email_id: e.accepted_vendor,
      bid_price: e.confirmed_value
    };

    this.setState({ paramsforrejection: rejectionParams });
  };

  cancelindent = (indent, bid) => {
    this.setState({ rejectModel: true, paramsforrejection: { indent, bid } });
  };
  onClickviewRFQ = async function (e) {
    let destination_info = e.data.indent
    const destinationDetails = JSON.parse(destination_info.destination || '[]');
    this.setState({
      isPreviewMode: true,
      rfqForm: e.data.indent,
      dealers: destinationDetails
    });
  };
  onClickComments = async function (e) {
    let indent = e.data.indent;

    const fields = [
      { label: 'Additional Comments', value: indent && indent.additional_comments },
      { label: 'Vendor Rejection Reason', value: indent && indent.reasonforrejectionbyvendor },
      { label: 'Admin Rejection Reason', value: indent && indent.rejected_reason_by_approval1 },
      { label: 'Danish Rejection Reason', value: indent && indent.rejection_reason_for_superadmin },
    ];

    const comment = fields
      .filter(field => field.value)
      .map(field => field.label + ': ' + field.value)
      .join('\n');

    this.setState({
      modelForAdditionalComments: true,
      additionalComments: comment || 'No comments provided'
    });
  };
  onClickmaterialdetails = async (params) => {

    if (params != 0) {
      await this.setState({
        detailCellRendererParams: {
          detailGridOptions: {
            columnDefs: material_columns
          },

          getDetailRowData: function (params) {
            const indent = params && params.data && params.data.indent;
            var destinationRaw = indent && indent.destination;
            var rowData = [];

            try {
              var destinations = JSON.parse(destinationRaw);

              destinations.forEach(function (dest) {
                dest.materials.forEach(function (material) {
                  rowData.push(Object.assign({}, dest, material));
                });
              });
            } catch (err) {
            }
            params.successCallback(rowData);
          }.bind(this),

          masterDetail: true
        }
      });


    }
    if (params.column.colDef.field == 'materials') {
      params.node.setExpanded(!params.node.expanded);
    }
    else {

      params.node.setExpanded(false);
    }
  }

  onClickbiddetails = async (params) => {
    let e = params.data
    this.setState({
      overlay: 'show-m',
      showsliderforbid: true,
    });

    const { originalindents } = this.state;

    // Set selected indent and fetch bid history
    this.setState((prevState) => {
      const currentlyOpen = prevState.iscardOpen;
      if (currentlyOpen === e.indent_id) {
        return {
          iscardOpen: "",
          selectedindent: {},
        };
      } else {
        this.getbidhistory(e.indent_id);
        return {
          iscardOpen: e.indent_id,
          selectedindent: e,
        };
      }
    });

    // Filter original indent and prepare destinations
    const data = originalindents.filter((f) => f.indent_id === e.indent_id);
    let destinations = [];
    let data1 = JSON.parse(data[0].destination);

    data1.forEach((g) => {
      destinations.push({
        indent_id: e.indent_id,
        dealer_city: g.dealer_city,
        dealer_pincode: g.dealer_pincode,
        dealer_code: g.dealer_code,
        quantity: g.quantity,
      });
    });

    // Fetch stored data and update bid/transit days
    const paramsStored = {
      indent_id: e.indent_id,
      vendor_email_id: localStorage.getItem("email"),
    };

    redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
      const transit_data = resp.data;

      transit_data.forEach((record) => {
        const match = destinations.find(
          (d) =>
            d.indent_id === record.indent_id &&
            d.dealer_city === record.dealer_city
        );
        if (match) {
          match.bid_price = record.bid_price;
          match.transit_days = record.transit_days;
        }
      });

      this.setState({
        indent_for_approve_for_bid: destinations,
        indent_for_approve_for_bid1: destinations,
      });
    });

    this.setState({
      inputTextValue: "",
      inputTextQuantity: "",
    });

    // Fetch LR data
    const paramsLR = { indent_id: e.indent_id };

    redirectURL.post("/consignments/getlr_data", paramsLR).then((resp) => {
      const data = resp.data;
      if (data && data !== "") {
        if (localStorage.getItem("roles") === "TRANSPORTER") {
          // If needed: filter by vendor_email_id
          // data = data.filter(f => f.vendor_email_id === localStorage.getItem("email"));
          this.setState({ lr_no_data: data });
        } else {
          this.setState({ lr_no_data: data });
        }
      }
    });

    // Fetch stored truck details
    redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
      const data1 = resp.data;
      let destinations = [];

      data1.forEach((f) => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: f.dealer_city,
          dealer_pincode: f.dealer_pincode,
          truck_no: f.truck_no,
          transit_days: f.transit_days,
          material: f.material,
        });
      });

      let indentfortruckdetails = [];
      data1.forEach((g) => {
        indentfortruckdetails.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          truck_no: g.truck_no,
          lr_no: g.lr_no,
        });
      });

      this.setState({
        indent_for_approve1: destinations,
        indentfortruckdetails: indentfortruckdetails,
      });
    });
    var params = {
      "indent_id": e.indent_id
    }
    redirectURL.post('/consignments/getadminbifurdata', params).then((resp) => {
      const bifurdata = [];
      const records = resp.data;

      records.forEach(g => {
        bifurdata.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_state: g.dealer_state,
          dealer_pincode: g.dealer_pincode,
          dealer_name: g.dealer_name,
          dealer_code: g.dealer_code,
          bid_price: g.bid_price,
          quantity: g.quantity
        });
      });

      this.setState({
        dataforadminbifur: bifurdata
      });
    });

  };
  gethistorydata = async (params) => {

    const indentId = params

    try {
      const response = await redirectURL.post("/consignments/getBidHistory", { indent_id: indentId });

      const bidHistory = Array.isArray(response.data.bid_history) ? response.data.bid_history : [];
      const negotiations = Array.isArray(response.data.negotiations) ? response.data.negotiations : [];
      const negotiationsLogs = Array.isArray(response.data.negotiationslogs) ? response.data.negotiationslogs : [];

      const originalIndent = this.state.originalindents.find(item => item.indent_id === indentId);

      this.setState({
        // overlay:'show-m',
        // showBidDetailsSlider: true, // ✅ this opens the slider
        selectedIndentData: originalIndent,
        selectedVendorQuotes: originalIndent && originalIndent.vendorquotes ? originalIndent.vendorquotes : [],
        bidHistory,
        negotiations,
        negotiationsLogs
      });

    } catch (error) {
    }
  };
  onClickshowbiddata = async (params) => {
    const indent = params.data && params.data.indent;
    if (!indent) return;

    const indentId = indent.indent_id;

    try {
      const response = await redirectURL.post("/consignments/getBidHistory", { indent_id: indentId });

      const bidHistory = Array.isArray(response.data.bid_history) ? response.data.bid_history : [];
      const negotiations = Array.isArray(response.data.negotiations) ? response.data.negotiations : [];
      const negotiationsLogs = Array.isArray(response.data.negotiationslogs) ? response.data.negotiationslogs : [];

      const originalIndent = this.state.originalindents.find(item => item.indent_id === indentId);

      this.setState({
        overlay: 'show-m',
        // showBidDetailsSlider: true, // ✅ this opens the slider
        selectedIndentData: originalIndent,
        selectedVendorQuotes: originalIndent && originalIndent.vendorquotes ? originalIndent.vendorquotes : [],
        bidHistory,
        negotiations,
        negotiationsLogs,
        selectedindentdata1: params.data
      });
      //   this.onClickbiddetails()

      let e = params.data

      const { originalindents } = this.state;

      // Set selected indent and fetch bid history
      this.setState((prevState) => {
        const currentlyOpen = prevState.iscardOpen;
        if (currentlyOpen === e.indent_id) {
          return {
            iscardOpen: "",
            selectedindent: {},
          };
        } else {
          this.getbidhistory(e.indent_id);
          return {
            iscardOpen: e.indent_id,
            selectedindent: e,
          };
        }
      });

      // Filter original indent and prepare destinations
      const data = originalindents.filter((f) => f.indent_id === e.indent_id);
      let destinations = [];
      let data1 = JSON.parse(data[0].destination);

      data1.forEach((g) => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          quantity: g.quantity,
        });
      });

      // Fetch stored data and update bid/transit days
      const paramsStored = {
        indent_id: e.indent_id,
        vendor_email_id: localStorage.getItem("email"),
      };

      redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
        const transit_data = resp.data;

        transit_data.forEach((record) => {
          const match = destinations.find(
            (d) =>
              d.indent_id === record.indent_id &&
              d.dealer_city === record.dealer_city
          );
          if (match) {
            match.bid_price = record.bid_price;
            match.transit_days = record.transit_days;
          }
        });

        this.setState({
          indent_for_approve_for_bid: destinations,
          indent_for_approve_for_bid1: destinations,
        });
      });

      this.setState({
        inputTextValue: "",
        inputTextQuantity: "",
      });

      // Fetch LR data
      const paramsLR = { indent_id: e.indent_id };

      redirectURL.post("/consignments/getlr_data", paramsLR).then((resp) => {
        const data = resp.data;
        if (data && data !== "") {
          if (localStorage.getItem("roles") === "TRANSPORTER") {
            // If needed: filter by vendor_email_id
            // data = data.filter(f => f.vendor_email_id === localStorage.getItem("email"));
            this.setState({ lr_no_data: data });
          } else {
            this.setState({ lr_no_data: data });
          }
        }
      });

      // Fetch stored truck details
      // redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
      //   const data1 = resp.data;
      //   let destinations = [];

      //   data1.forEach((f) => {
      //     destinations.push({
      //       indent_id: e.indent_id,
      //       dealer_city: f.dealer_city,
      //       dealer_pincode: f.dealer_pincode,
      //       truck_no: f.truck_no,
      //       transit_days: f.transit_days,
      //       material: f.material,
      //     });
      //   });

      //   let indentfortruckdetails = [];
      //   data1.forEach((g) => {
      //     indentfortruckdetails.push({
      //       indent_id: e.indent_id,
      //       dealer_city: g.dealer_city,
      //       dealer_pincode: g.dealer_pincode,
      //       dealer_code: g.dealer_code,
      //       truck_no: g.truck_no,
      //       lr_no: g.lr_no,
      //     });
      //   });

      //   this.setState({
      //     indent_for_approve1: destinations,
      //     indentfortruckdetails: indentfortruckdetails,
      //   });
      // });
      var params = {
        "indent_id": e.indent_id
      }
      redirectURL.post('/consignments/getadminbifurdata', params).then((resp) => {
        var bifurdata = []
        var records = resp.data
        records.map((g) => {
          bifurdata.push({
            "indent_id": e.indent_id,
            "dealer_city": g.dealer_city,
            "dealer_state": g.dealer_state,
            'dealer_pincode': g.dealer_pincode,
            "dealer_name": g.dealer_name,
            "dealer_code": g.dealer_code,
            "bid_price": g.bid_price,
            "quantity": g.quantity,

          })
        })

        this.setState({
          dataforadminbifur: bifurdata,
          indentfortruckdetails: bifurdata
        }, () => {
          // This will execute after state is updated
          this.setState({
            bidDetailsform: true,
            // showBidDetailsSlider: true // Open Modal AFTER data is ready
          });
        });



      })
    }
    catch (error) {
    }
  };
  onclickreject = () => {
    if (this.state.approval1RejectionReason != '' && this.state.approval1RejectionReason != undefined) {
      const params = {
        ...this.state.paramsforrejection,
        rejection_reason: this.state.approval1RejectionReason,
        email : localStorage.getItem("email")
      };
      redirectURL.post("/consignments/rejectedindentwithsuperadmin", params).then(response => {
        this.setState({
          showsweetalert: true,
          basicType: "success",
          basicTitle: (
            <>
              Indent <b>{response.data.indent_id}</b> has been rejected
            </>
          ),
          rejectModel: false,
          showBidDetailsSlider: false,
          overlay: 'show-n'
        });

        this.resetindent(); // Make sure this method exists in your class
      });
    }

  };


  fetchInitialData = () => {
    this.setState({ loadshow: "show-m" });
    const { selectedfromdate, selectedenddate } = this.state;
    console.log(selectedfromdate, selectedenddate)
    const params = {
      user_type: localStorage.getItem("user_type"),
      email: localStorage.getItem("email"),
      from_date: selectedfromdate,
      to_date: selectedenddate

    };

    redirectURL.post("/consignments/fetchRFQsForDashboard", params).then((response) => {
      const record = response.data;

      // Split into draft and non-draft
      const pendingData = record.filter((item) =>
        item.indent_assigned !== 1 &&
        item.approvedwithapproval1 === 1 &&
        item.rejectedwithapproval2 !== 1 &&
        item.approvedwithapproval2 !== 1 &&
        item.rejected !== 1 &&
        item.waiting_for_approval1 == 1 &&
        !['Expired', 'Negotiation In Progress'].includes(this.getStatusFromIndent(item))
      );

      const approvedData = record.filter(
        (item) => item.approvedwithapproval2 === 1 && item.rejected !== 1 && item.waiting_for_approval1 != 1
      );

      const rejectedData = record.filter(
        (item) => item.rejected === 1
      );
      const nonDraftData = [...pendingData, ...approvedData, ...rejectedData]
      const draftData = record.filter((e) => e.is_draft === 1);


      this.setState({
        draftdata: draftData,
        originalindents: nonDraftData,
        alldata: nonDraftData,
        indentsdata: nonDraftData
      });

      this.getcountersforindents(nonDraftData);

      const filteredData = nonDraftData.filter((e) =>
        e.indent_assigned !== 1 &&
        e.approvedwithapproval1 === 1 &&
        e.rejectedwithapproval2 !== 1 &&
        e.approvedwithapproval2 !== 1 &&
        e.rejected !== 1 &&
        !['Expired', 'Negotiation In Progress'].includes(this.getStatusFromIndent(e))
      );


      this.setState((prevState) => ({
        rfqform: {
          ...prevState.rfqform,
          total: '',
          pending: 'activet1',
          approved: '',
          rejected: ''
        },
        allindents: filteredData,
        loadshow: "show-n"
      }));

      // Unused records filtering (you can store if needed)
      const assignedIndents = nonDraftData.filter((e) => e.indent_assigned === 1);
      // this.setState({ assignedIndents }); // If needed
    });
  };



  resetindent = async () => {
    await this.fetchInitialData();
    const { rfqform, originalindents, selectedindent } = this.state;
    let awardeddata = [];

    if (rfqform.awarded === 'activet1') {
      if (localStorage.getItem('user_type') === 'TRANSPORTER') {
        awardeddata = originalindents.filter(e => e.accepted_vendor === localStorage.getItem('email') && e.vehicle_placement_expiried != 1 && e.rejected != 1);
        awardeddata = awardeddata.filter(e => {
          if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
            const vendorquote = e.vendorquotes.find(quote =>
              quote.vendor_email_id === localStorage.getItem('email') &&
              quote.indent_rejected_by_vendor != 1 &&
              quote.indent_accepted_by_vendor === 1
            );
            return vendorquote !== undefined;
          }
          return false;
        });
      } else {
        awardeddata = originalindents.filter(e => e.indent_assigned == 1 && e.indent_rejected_by_vendor != 1 && e.vehicle_placement_expiried != 1 && e.indent_cancelled != 1);
      }
      this.setState({ loadshow: 'show-n', allindents: awardeddata });
    }

    if (selectedindent.indent_id) {
      this.getbidhistory(selectedindent.indent_id);
      this.gethistorydata(selectedindent.indent_id)
      const params = { indent_id: selectedindent.indent_id };
      redirectURL.post('/consignments/getlr_data', params).then(resp => {
        if (resp && resp.data) {
          const data = resp.data;
          if (data !== '') {
            this.setState({ lr_no_data: data });
          }
        }
      });
    }
  };

  refreshindent = async () => {
    await this.fetchInitialData();
    const { rfqform, originalindents, selectedindent } = this.state;
    let awardeddata = [];

    if (rfqform.awarded === 'activet1') {
      if (localStorage.getItem('user_type') === 'TRANSPORTER') {
        awardeddata = originalindents.filter(e => e.accepted_vendor === localStorage.getItem('email') && e.vehicle_placement_expiried != 1 && e.rejected != 1);
        awardeddata = awardeddata.filter(e => {
          if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
            const vendorquote = e.vendorquotes.find(quote =>
              quote.vendor_email_id === localStorage.getItem('email') &&
              quote.indent_rejected_by_vendor != 1 &&
              quote.indent_accepted_by_vendor === 1
            );
            return vendorquote !== undefined;
          }
          return false;
        });
      } else {
        awardeddata = originalindents.filter(e => e.indent_assigned == 1 && e.indent_rejected_by_vendor != 1 && e.vehicle_placement_expiried != 1 && e.indent_cancelled != 1);
      }
      this.setState({ loadshow: 'show-n', allindents: awardeddata });
    }

    if (selectedindent.indent_id) {
      this.getbidhistory(selectedindent.indent_id);
      const params = { indent_id: selectedindent.indent_id };
      redirectURL.post('/consignments/getlr_data', params).then(resp => {
        if (resp && resp.data) {
          const data = resp.data;
          if (data !== '') {
            this.setState({ lr_no_data: data });
          }
        }
      });
    }
  };

  acceptindentbyvendor = (indent) => {
    const params = {
      indent_id: indent.indent_id,
      accepted_vendor: indent.accepted_vendor
    };
    redirectURL.post('/consignments/acceptindentbyvendor', params).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: 'You have successfully accepted the indent.'
      });
      this.resetindent();
    });
  };


  onSubmitdataforrejection = () => {
    const { selectedindentforvendor, rejectionReasonbyvendor } = this.state;
    const params = {
      indent_id: selectedindentforvendor.indent_id,
      accepted_vendor: selectedindentforvendor.accepted_vendor,
      rejectionreason: rejectionReasonbyvendor
    };

    redirectURL.post('/consignments/rejectindentbyvendor', params).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'danger',
        basicTitle: 'You have successfully rejected the indent.',
      });
      this.resetindent();
    });
  };

  getbidhistory = async (indent_id) => {
    await redirectURL.post("/consignments/getBidHistory", { indent_id }).then(response => {
      this.setState({
        bidHistory: response.data.bid_history,
        negotiations: response.data.negotiations,
        negotiationsHistory: response.data.negotiationslogs
      });
    });
  };

  isBiddingWindowExpired = (biddingWindow, createDate) => {
    if (!biddingWindow || !biddingWindow.includes(':') || !createDate) {
      return true;
    }

    const [hours, minutes] = biddingWindow.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) {
      return true;
    }

    const localCreateDate = new Date(createDate.replace('Z', '') + '+05:30');
    const biddingEndTime = new Date(localCreateDate);

    biddingEndTime.setHours(biddingEndTime.getHours() + hours);
    biddingEndTime.setMinutes(biddingEndTime.getMinutes() + minutes);

    const currentTime = new Date();

    return currentTime > biddingEndTime;
  };

  deletedraftindent = (e) => {
    if (window.confirm(`Are you sure you want to delete draft ${e}?`)) {
      const params = { draft_id: e };
      redirectURL.post('/consignments/deletedraftindent', params).then((resp) => {
        this.setState({
          showsweetalert: true,
          basicType: 'success',
          basicTitle: `Draft ${e} has been deleted`
        });
        this.resetindent();
      }).catch((err) => {
        this.setState({
          showsweetalert: true,
          basicType: 'error',
          basicTitle: 'Failed to delete draft'
        });
      });
    }
  };
  onClickBidNow = async (e) => {
    const { originalindents } = this.state;

    this.setState(prevState => {
      if (prevState.isCardOpen === e.indent_id) {
        return { isCardOpen: '', selectedindent: {} };
      } else {
        this.getbidhistory(e.indent_id);
        return { isCardOpen: e.indent_id, selectedindent: e };
      }
    });

    const data = originalindents.filter(f => f.indent_id === e.indent_id);
    let destinations = [];
    let data1 = JSON.parse(data[0].destination);
    data1.forEach(g => {
      destinations.push({
        indent_id: e.indent_id,
        dealer_city: g.dealer_city,
        dealer_pincode: g.dealer_pincode,
        dealer_code: g.dealer_code,
        quantity: g.quantity
      });
    });


    const params1 = {
      indent_id: e.indent_id,
      vendor_email_id: localStorage.getItem('email')
    };

    redirectURL.post('/consignments/getstroreddata', params1).then(resp => {
      const transit_data = resp.data;
      transit_data.forEach(transitRecord => {
        const destinationRecord = destinations.find(dest =>
          dest.indent_id === transitRecord.indent_id &&
          dest.dealer_city === transitRecord.dealer_city
        );
        if (destinationRecord) {
          destinationRecord.bid_price = transitRecord.bid_price;
          destinationRecord.transit_days = transitRecord.transit_days;
        }
      });

      this.setState({
        indent_for_approve_for_bid: destinations,
        indent_for_approve_for_bid1: destinations,
        inputTextValue: "",
        inputTextQuantity: ""
      });
    });

    const paramsForLRData = { indent_id: e.indent_id };
    redirectURL.post('/consignments/getlr_data', paramsForLRData).then(resp => {
      const data = resp.data;
      if (data && data !== '') {
        this.setState({ lr_no_data: data });
      }
    });

    const params3 = {
      indent_id: e.indent_id,
      vendor_email_id: localStorage.getItem('email')
    };
    redirectURL.post('/consignments/getstroreddata', params3).then(resp => {
      const data1 = resp.data;
      let destinations = [];
      data1.map(f => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: f.dealer_city,
          dealer_pincode: f.dealer_pincode,
          truck_no: f.truck_no,
          transit_days: f.transit_days,
          material: f.material
        });
      });
      this.setState({ indent_for_approve1: destinations });

      let indentfortruckdetails = [];
      data1.forEach(g => {
        indentfortruckdetails.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          truck_no: g.truck_no,
          lr_no: g.lr_no
        });
      });

      this.setState({ indentfortruckdetails });
    });
    var params = {
      "indent_id": e.indent_id
    }
    redirectURL.post('/consignments/getadminbifurdata', params).then((resp) => {
      const bifurdata = resp.data.map(g => ({
        indent_id: e.indent_id,
        dealer_city: g.dealer_city,
        dealer_state: g.dealer_state,
        dealer_pincode: g.dealer_pincode,
        dealer_name: g.dealer_name,
        dealer_code: g.dealer_code,
        bid_price: g.bid_price,
        quantity: g.quantity
      }));

      this.setState({ dataforadminbifur: bifurdata });
    });

  };

  changeFileHandler = (e) => {
    const formData = new FormData();
    formData.append("fileUpload", e.target.files[0]);
    // You can add logic here for upload if needed
  };

  closeBulkUploadModal = () => {
    this.setState({
      bulkUploadModal: {
        overly: "show-n",
        bulkPrioritySlide: ""
      },
      overlay: "show-n"
    });
  };

  onClickHideall = () => {
    this.setState({
      loadshow: 'show-n',
      overlay: 'show-n',
      showBidDetailsSlider: false,
      modelForNotifications: false,

    });
  };
  onClickAcceptNegotiation = (indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by) => {
    const params = {
      indent_id,
      bid_price,
      no_of_deliveries,
      vendor_email_id,
      email: localStorage.getItem("email"),
      user_type: localStorage.getItem("user_type"),
      indent_created_by
    };

    redirectURL.post("/consignments/acceptNegotiationValue", params).then(response => {
      const isSuccess = response.data.status === "success";
      this.setState({
        showsweetalert: true,
        basicType: isSuccess ? "success" : "danger",
        basicTitle: 'Negotiated value has been accepted successfully.'
      });

      if (isSuccess) {
        this.setState({
          isVendorInputOpen: "",
          isProposedInputOpen: ""
        });
        this.resetindent();
      }
    }).catch(error => {
      this.setState({
        showsweetalert: true,
        basicType: "danger",
        basicTitle: "An error occurred while processing the request."
      });
    });
  };

  onShowdata = (indent_id) => {
    this.setState({ storedTrucksModel: true });
    const params = {
      indent_id: indent_id,
      vendor_email_id: localStorage.getItem('email')
    };

    redirectURL.post('/consignments/getstroreddata', params).then(resp => {
      const data1 = resp.data;
      const destinations = data1.map(e => ({
        indent_id: indent_id,
        dealer_city: e.dealer_city,
        dealer_pincode: e.dealer_pincode,
        bid_price: e.bid_price,
        truck_no: e.truck_no,
        lr_no: e.lr_no
      }));
      this.setState({ indent_for_approve1: destinations });
    });
  };
  onCloseSlider = () => {
    this.setState({
      overlay: 'show-n',
      showsliderforbid: false,
    })
  }
  onSubmitdataforadminbifurcation = () => {
    const { dataforadminbifur } = this.state;
    const negotiatedconfirmed_price = dataforadminbifur[0].negotiatedconfirmed_price;
    const totalBidPrice = dataforadminbifur.reduce((sum, item) => {
      return sum + (parseFloat(item.bid_price) || 0);
    }, 0);

    if (totalBidPrice === negotiatedconfirmed_price) {
      const params1 = {
        indent_id: dataforadminbifur[0].indent_id,
        bid_price: negotiatedconfirmed_price,
        vendor_email_id: dataforadminbifur[0].vendor_email_id,
        email: localStorage.getItem("email"),
        user_type: localStorage.getItem("user_type"),
        indent_created_by: dataforadminbifur[0].indent_created_by
      };

      redirectURL.post("/consignments/AcceptQuotationwithadmin", params1).then(response => {
        const isSuccess = response.data.status === "success";
        if (isSuccess) {
          this.setState({
            isVendorInputOpen: "",
            isProposedInputOpen: "",
            isCardOpen1: false
          });
        }
      }).catch(error => {
        this.setState({
          showsweetalert: true,
          basicType: "danger",
          basicTitle: "An error occurred while processing the request."
        });
      });

      redirectURL.post('/consignments/storeadminbifur', dataforadminbifur).then(resp => {
        this.setState({
          showsweetalert: true,
          basicType: "success",
          basicTitle: 'Vendor value has been accepted successfully.',
          cardforadminbifurcation: false
        });
        this.resetindent();
      });
    } else {
      this.setState({
        showsweetalert: true,
        basicType: "danger",
        basicTitle: 'Bifurcation bid price must equal bid price'
      });
    }
  };
  onClickallcomments = async (params) => {
    if (params !== 0) {
      await this.setState({
        detailCellRendererParams: {
          detailGridOptions: {
            columnDefs: comments_logs_columns
          },
          getDetailRowData: function (gridParams) {
            var indent = gridParams && gridParams.data && gridParams.data.indent;
            if (!indent) {
              gridParams.successCallback([]);
              return;
            }

            var requestParams = { indent_id: indent.indent_id };

            redirectURL.post('/consignments/getallactionlogs', requestParams)
              .then(function (response) {
                if (response.data && Array.isArray(response.data)) {
                  let data = response.data;
                  // Transporter Role Filter

                  // Sort data by latest action_time first
                  data.sort((a, b) => new Date(b.action_time) - new Date(a.action_time));

                  // Remove Duplicate Actions (unique by 'action' text)
                  const uniqueActionsMap = new Map();
                  const uniqueData = [];

                  data.forEach(item => {
                    if (!uniqueActionsMap.has(item.action)) {
                      uniqueActionsMap.set(item.action, true);
                      uniqueData.push(item);
                    }
                  });

                  gridParams.successCallback(uniqueData);
                } else {
                  gridParams.successCallback([]);
                }
              })
              .catch(function (error) {
                gridParams.successCallback([]);
              });
          },

          masterDetail: true
        }
      });
    }
    if (params.column && params.column.colDef && params.column.colDef.field === 'allcomments') {
      params.node.setExpanded(!params.node.expanded);
    } else {
      params.node.setExpanded(false);
    }
  };

  onClickAcceptQuotation = (indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by, indent, vendorValue) => {
    if (localStorage.getItem('rfq_role') == 'ADMIN') {
      this.setState({ cardforadminbifurcation: true });
      const { originalindents } = this.state;
      const data = originalindents.filter(f => f.indent_id === indent_id);

      let destinations = [];
      let data1 = JSON.parse(data[0].destination);
      data1.forEach(g => {
        destinations.push({
          indentId: indent_id,
          dealerCity: g.dealer_city,
          dealerState: g.dealer_state,
          negotiatedConfirmedPrice: vendorValue,
          dealerPincode: g.dealer_pincode,
          dealerName: g.dealer_name,
          dealerCode: g.dealer_code,
          vendorEmailId: vendor_email_id,
          indentCreatedBy: indent_created_by,
          materials: g.materials.map(material => ({
            materialType: material.material_type === 'others'
              ? material.other_material_type
              : material.material_type,
            materialDimensions: `${material.material_length} x ${material.material_breath} x ${material.material_height}`,
            quantity: material.quantity
          })),
          quantity: g.quantity
        });
      });

      this.setState({ dataforadminbifur: destinations });
    }
  };

  onCloseModal = () => {
    this.setState({
      modelForAdditionalComments: false,
      modelForNotifications: false,
      modelForEditAssigned: false,
      isCardOpen1: false,
      storedTrucksModel: false,
      isCardOpen3: false,
      cardforadminbifurcation: false,
      rejectModel: false,
      overlay: 'show-n',
      overly: 'show-n',
    });
  };

  getIndentStatus = (indent) => {
    const userType = localStorage.getItem("user_type");
    const email = localStorage.getItem("email");

    // Rejected
    if (indent.rejected === 1 || indent.indentcancelledbyadmin === 1) {
      return "Rejected";
    }

    // Approved
    if (indent.approvedwithapproval2 === 1 && indent.rejected !== 1) {
      return "Approved";
    }

    // Pending
    if (userType === "TRANSPORTER") {
      if (
        indent.vendorquotes &&
        indent.vendorquotes.some(
          (quote) => quote.vendor_email_id === email && quote.bid_winner === 1
        )
      ) {
        return "Pending";
      }
    } else {
      if (
        indent.indent_assigned !== 1 &&
        indent.approvedwithapproval1 === 1 &&
        indent.rejectedwithapproval2 !== 1 &&
        indent.approvedwithapproval2 !== 1 &&
        indent.rejected !== 1
      ) {
        return this.getStatusFromIndent(indent)
      }
    }

    // Default
    return "";
  };

  fetchNotificationsData = (e) => {
    let indent_id = e.data.indent_id
    const params = {
      email: localStorage.getItem("email"),
      indent_id: indent_id
    };

    redirectURL.post("/consignments/fetchNotificationsData", params).then(response => {
      this.setState({
        notificationUnread: response.data.Unreadnotifications,
        notificationRead: response.data.Readnotifications,
        modelForNotifications: true,
        overlay: 'show-m',
        overly: 'show-m',
        selectedindentfornofication: indent_id

      });

      const { allindents } = this.state;
      const updatedIndents = allindents.map(indent => {
        if (indent.indent_id === indent_id) {
          return { ...indent, notification_count: 0 };
        }
        return indent;
      });

      this.setState({ allindents: updatedIndents });
    });
  };


  handlerStartDateTime = (event, currentDate, selectedDate) => {
    const d = new Date(event._d);
    const startdate = d.getFullYear() + "-" + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate());
    this.setState({ selectedfromdate: startdate });
  };

  handlerEndDateTime = (event, currentDate, selectedDate) => {
    const d = new Date(event._d);
    const startdate = d.getFullYear() + "-" + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate());
    this.setState({ selectedenddate: startdate });
  };

  handleSelectChange = (name, selectedOption) => {
    const { searchfilter } = this.state;
    this.setState({
      searchfilter: {
        ...searchfilter,
        [name]: selectedOption ? selectedOption.value : null
      }
    });
  };

  resetSearchFilter = () => {
    this.setState((prev) => ({ filterToggle: !prev.filterToggle }))
    const { rfqform, originalindents, alldata } = this.state;
    const updatedRfqForm = {
      ...rfqform,
      cancelled: '',
      total: 'activet1',
      active: '',
      completed: '',
      awarded: '',
      rejected: '',
      Delivered: '',
      vendorrejected: '',
      vehicle_placement_missed: '',
      drafts: ''
    };

    let filteredIndents = alldata;

    if (rfqform.active === 'activet') {
      filteredIndents = originalindents.filter(e => e.indent_expired != 1);
    } else if (rfqform.cancelled === 'activet') {
      filteredIndents = originalindents.filter(e => e.indent_expired == 1);
    }

    this.setState({
      rfqform: updatedRfqForm,
      allindents: filteredIndents,
      originalindents: alldata,
      searchfilter: {}
    });

    this.getcountersforindents(alldata, []);
  };

  getStatusFromIndent = (indent) => {
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      return this.getIndentStatus(indent);
    }

    switch (true) {
      case indent.rejected === 1:
      case indent.indentcancelledbyadmin === 1:
        return 'Indent Rejected';
      case indent.vehicle_placement_expiried === 1:
      case indent.validity_end === 1 || (
        indent.bidding_window &&
        indent.create_date &&
        this.isBiddingWindowExpired(indent.bidding_window, indent.create_date) &&
        indent.vendorquotes &&
        indent.vendorquotes.length === 0
      ):
        return 'Expired';

      case indent.is_draft === 1:
        return 'Draft';
      case indent.truck_details_completed === 1:
        return 'Vehicle Placed';
      case indent.indent_rejected_by_vendor === 1:
        return 'Award Declined';
      case indent.waiting_for_approval1 === 1 && indent.changed_l2_as_l1 == 1:
        return 'Awaiting Approval to Consider L2 as L1';
      case indent.waiting_for_approval1 === 1:
        return 'Awaiting Approval';
      case indent.vendorquotes && indent.vendorquotes.some(e => e.in_negotiation === 1):
        return 'Negotiation In Progress';
      case indent.approved_changed_l2_as_l1 === 1:
        return 'Negotiation In Progress';
      case indent.vendorquotes && indent.vendorquotes.some(e => e.vendor_email_id == indent.accepted_vendor && e.indent_accepted_by_vendor == 1) && indent.truck_details_completed != 1:
        return 'Awaiting Truck Details'
      case indent.approvedwithapproval2 === 1:
        return 'Indent Awarded';

      case indent.vendorquotes && indent.vendorquotes.length === 0:
        return 'Bidding In Progress';
      case indent.quantity === indent.confirmed_quantity || indent.indent_assigned === 1:
        return 'Indent Awarded';
      default:
        return 'Bidding In Progress';
    }
  };

  getindents = (e) => {
    e.preventDefault();
    const { alldata, searchfilter } = this.state;
    console.log(alldata, "line_no_2276")


    const filteredIndents = alldata.filter((item) => {
      return Object.entries(searchfilter).every(([key, value]) => {
        if (!value) return true;

        if (key === 'status') {
          const currentStatus = this.getIndentStatus(item);
          return currentStatus.toLowerCase() === value.toLowerCase();
        }

        if (item[key] && typeof item[key] === 'string' && typeof value === 'string') {
          return item[key].toLowerCase() === value.toLowerCase();
        } else {
          return item[key] == value;
        }
      });
    });
    this.onClickparentTab("total")
    this.setState({
      allindents: filteredIndents,
      originalindents: filteredIndents
    });
    this.getcountersforindents(filteredIndents, []);
  };

  handleInputChangeforaccept = (index, field, value) => {
    const updatedDestinations = [...this.state.indent_for_approve];
    updatedDestinations[index][field] = value;
    this.setState({ indent_for_approve: updatedDestinations });
  };

  handleInputChangeforacceptfortruck = (index, field, value) => {
    const updatedDestinations = [...this.state.indentfortruckdetails];
    updatedDestinations[index][field] = value;
    this.setState({ indentfortruckdetails: updatedDestinations });
  };

  handleInputChangeforacceptfortruck1 = (index, field, value) => {
    const updatedDestinations = [...this.state.lr_no_data];
    updatedDestinations[index][field] = value;
    this.setState({ lr_no_data: updatedDestinations });
  };

  handleInputChangeforadmin_bifur = (index, field, value) => {
    const updatedDestinations = [...this.state.dataforadminbifur];
    updatedDestinations[index][field] = value;
    this.setState({ dataforadminbifur: updatedDestinations });
  };

  onSubmitdata = () => {
    const { indent_for_approve, selecteddata } = this.state;
    const hasInvalidFields = indent_for_approve.some(destination => !destination.bid_price || !destination.transit_days);

    if (hasInvalidFields) {
      alert("Please fill in all Bid Price and Transit Days fields before submitting.");
      return;
    }

    const submissionData = indent_for_approve.map(destination => ({
      indent_id: destination.indent_id,
      dealer_city: destination.dealer_city,
      dealer_pincode: destination.dealer_pincode,
      bid_price: destination.bid_price,
      transit_days: destination.transit_days,
      material: destination.material,
      vendor_email_id: localStorage.getItem('email'),
      vendor_name: localStorage.getItem('firstname')
    }));

    const params1 = { submissionData };
    redirectURL.post('/consignments/storedata', params1);

    const { indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by } = selecteddata;
    const params = {
      indent_id,
      bid_price,
      no_of_deliveries,
      vendor_email_id,
      email: localStorage.getItem("email"),
      user_type: localStorage.getItem("user_type"),
      indent_created_by
    };

    redirectURL.post("/consignments/acceptNegotiationValue", params).then(response => {
      const isSuccess = response.data.status === "success";
      this.setState({
        showsweetalert: true,
        basicType: isSuccess ? "success" : "danger",
        basicTitle: response.data.message,
        isCardOpen1: false
      });

      if (isSuccess) {
        this.setState({
          isVendorInputOpen: "",
          isProposedInputOpen: ""
        });
      }
    }).catch(error => {
      this.setState({
        showsweetalert: true,
        basicType: "danger",
        basicTitle: "An error occurred while processing the request."
      });
    });
  };

  onshowPreview = (e) => {
    const destinationDetails = JSON.parse(e.destination || '[]');
    this.setState({
      isPreviewMode: true,
      rfqform: e,
      dealers: destinationDetails
    });
  };

  onSubmitdata1 = (e) => {
    const { lr_no_data, indentfortruckdetails } = this.state;
    let submissionData = [];

    if (e.started_truck_details === 1) {
      submissionData = lr_no_data.map(destination => ({
        indent_id: destination.indent_id,
        dealer_city: destination.dealer_city,
        dealer_pincode: destination.dealer_pincode,
        truck_no: destination.truck_no,
        lr_no: destination.lr_no || null
      }));
    } else {
      submissionData = indentfortruckdetails.map(destination => ({
        indent_id: destination.indent_id,
        dealer_city: destination.dealer_city,
        dealer_pincode: destination.dealer_pincode,
        truck_no: destination.truck_no,
        lr_no: destination.lr_no || null,
        submitted: 1,
        started_truck_details: 1
      }));
    }

    const params1 = { submissionData };
    redirectURL.post('/consignments/storetruckdetails', params1).then(resp => {
      this.setState({
        showsweetalert: true,
        basicType: "success",
        basicTitle: 'Truck details updated successfully',
        storedTrucksModel: false
      });
      this.resetindent();
    });
  };

  handleInputChange = (e) => {
    this.setState({ selected_transit_days: e });
  };

  handleInputChange1 = (e) => {
    this.setState({ selected_bid_price: e });
  };
  handleBidPriceChange = (value) => {
    this.setState({ selected_bid_price: value });
  };

  handleTransitDaysChange = (value) => {
    this.setState({ selected_transit_days: value });
  };
  onSubmitquote = (e) => {
    e.preventDefault();
    const {
      selected_bid_price,
      selected_transit_days,
      selectedindent,
      indent_for_approve_for_bid
    } = this.state;

    const params = {
      bid_price: selected_bid_price,
      transit_time: selected_transit_days,
      email: localStorage.getItem('email'),
      indent_id: selectedindent.indent_id,
      username: localStorage.getItem('user_name')
    };

    this.setState({ loadshow: 'show-m', overlay: 'show-m' });

    redirectURL.post('consignments/submitQuote', params).then(response => {
      if (response.data.status === 'success') {
        this.setState({
          loadshow: 'show-n',
          overlay: 'show-n',
          isCardOpen: "",
          showsweetalert: true,
          basicType: "success",
          basicTitle: 'Your Bid has been successfully placed',
          selected_bid_price: "",
          selected_transit_days: "",
          showsliderforbid: false,
        });

        this.resetindent();
      }
    });

    const submissionData = indent_for_approve_for_bid.map(destination => ({
      indent_id: selectedindent.indent_id,
      dealer_city: destination.dealer_city,
      dealer_pincode: destination.dealer_pincode,
      bid_price: destination.bid_price,
      transit_days: destination.transit_days,
      material: destination.material,
      vendor_email_id: localStorage.getItem('email'),
      vendor_name: localStorage.getItem('firstname')
    }));

    const params3 = { submissionData, indent_id: selectedindent.indent_id };
    redirectURL.post('/consignments/updatebidprice', params3);

    const params1 = { submissionData };
    redirectURL.post('/consignments/storedata', params1);
  };

  closeAlert = () => {
    this.setState({ showsweetalert: false, open: false });
  };


  onIconHover = (rowId) => {
    this.setState({ hoveredIconId: rowId });
  };
  onClickViewPOD = (e) => {
    let indent = e.data.indent
    const params = { pod_document: indent.upload_for_road };
    redirectURL.post("/billing/downloadfileforroad", params, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("userid")
      }
    }).then(res => {
      const downloadUrl = decodeURIComponent(res.data.url);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", e || "");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch(error => {
      // Handle error silently
    });
  };

  onClickcreateindent = () => {
    this.setState({ redirect: true });
  };
  tabNames = {
    pending: "Pending",
    approved: "Approved",
    Delivered: "Delivered",
    vendorrejected: "Vendor Declined",
    Drafts: "Drafts",
    rejected: "Rejected",
    Completed: "Expired",
    total: "All"
  };
  onClickparentTab = (e) => {
    var current_date = new Date();
    let data = [];
    const tabLabel = this.tabNames[e] || e;
    this.setState({ selectedTab: tabLabel });
    const userType = localStorage.getItem('user_type');
    const userEmail = localStorage.getItem('email');

    // Update rfqform state for active tab
    const setTab = (activeTab) => {
      this.setState((prevState) => ({
        rfqform: {
          ...prevState.rfqform,
          total: '',
          pending: '',
          approved: '',
          rejected: '',
          cancelled: '',
          active: '',
          drafts: '',
          [activeTab]: 'activet1',
        },
      }));
    };

    // Tab filters
    if (e === 'total') {
      setTab('total');

      const pendingData = this.state.originalindents.filter((item) =>
        item.indent_assigned !== 1 &&
        item.approvedwithapproval1 === 1 &&
        item.rejectedwithapproval2 !== 1 &&
        item.approvedwithapproval2 !== 1 &&
        item.rejected !== 1 &&
        item.waiting_for_approval1 == 1 &&
        !['Expired', 'Negotiation In Progress'].includes(this.getStatusFromIndent(item))
      );

      const approvedData = this.state.originalindents.filter(
        (item) => item.approvedwithapproval2 === 1 && item.rejected !== 1 && item.waiting_for_approval1 != 1
      );

      const rejectedData = this.state.originalindents.filter(
        (item) => item.rejected === 1
      );

      console.log(pendingData, approvedData, rejectedData, "line_no_2116")

      // merge & remove duplicates
      const map = new Map();
      [...pendingData, ...approvedData, ...rejectedData].forEach(item => {
        map.set(item._id, item);
      });
      data = Array.from(map.values());
    }
    else if (e === 'pending') {
      setTab('pending');
      data = this.state.originalindents.filter((item) =>
        item.indent_assigned !== 1 &&
        item.approvedwithapproval1 === 1 &&
        item.rejectedwithapproval2 !== 1 &&
        item.approvedwithapproval2 !== 1 &&
        item.rejected !== 1 &&
        item.waiting_for_approval1 == 1 &&
        !['Expired', 'Negotiation In Progress'].includes(this.getStatusFromIndent(item))
      );
    } else if (e === 'approved') {
      setTab('approved');
      data = this.state.originalindents.filter(
        (item) => item.approvedwithapproval2 === 1 && item.rejected !== 1 && item.waiting_for_approval1 != 1
      );
    } else if (e === 'rejected') {
      setTab('rejected');
      data = this.state.originalindents.filter((item) => item.rejected === 1);
    }

    // Apply search filters from state
    const filterdata = data.filter((indent) => {
      return Object.keys(this.state.searchfilter).every((key) => {
        return (
          !this.state.searchfilter[key] ||
          indent[key] === this.state.searchfilter[key]
        );
      });
    });

    this.setState({ allindents: filterdata });
  };

  submitNegotiateValue = (indent_id, vendor_email_id, indent_created_by) => {
    const inputValue = this.state.inputTextValues[vendor_email_id];
    const proposed_days = this.state.proposedDays[vendor_email_id];
    const params = {
      user_type: localStorage.getItem("user_type"),
      email: localStorage.getItem("email"),
      indent_id,
      negotiated_value: inputValue,
      negotiated_quantity: proposed_days,
      vendor_email_id,
      indent_created_by
    };

    redirectURL.post("/consignments/submitNegotiateValue", params)
      .then(response => {
        const { status, message } = response.data;
        this.setState({
          showsweetalert: true,
          basicType: status === 'success' ? 'success' : 'danger',
          basicTitle: 'The negotiated value has been updated'
        });
        this.resetindent();

        if (status === "success") {
          this.setState({
            isProposedInputOpen: "",
            isVendorInputOpen: ""
          });
        }
      })
      .catch(error => {
        this.setState({
          showsweetalert: true,
          basicType: "danger",
          basicTitle: "An error occurred while submitting the negotiation."
        });
      });
  };

  toggleShowAllRecords = () => {
    this.setState((prevState) => ({ showAllRecords: !prevState.showAllRecords }));
  };

  onClickcancelindent = (indent, bid) => {
    const params = { indent, bid };
    redirectURL.post('/consignments/cancelindent', params).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: 'Indent cancelled successfully'
      });
      this.resetindent();
    });
  };


  onClickchangerankbtn = (indent, bid) => {
    const params = { indent, bid };
    redirectURL.post('/consignments/changerankforvendorrejection', params).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: 'Successfully changed L2 as L1'
      });
      this.resetindent();
    });
  };
  render() {

    const columnDefs = [
      ...(this.state.selectedTab == 'Pending Indents'
        ? [
          {
            headerName: "",
            field: "materials",
            width: 190,
            pinned: 'left',
            cellRenderer: 'Actionforsuperadmincomponent',
            filter: false,

          },
        ]
        : []),

      {
        headerName: "",
        field: "materials",
        width: 40,
        pinned: 'left',
        cellRenderer: 'Materialcomponent',
        filter: false,

      },
      ...(userType === "TRANSPORTER"
        ? [
          {
            headerName: "",
            field: "_id",
            width: 120,
            pinned: "left",
            cellRenderer: "LoadingAreaLegs",
            filter: false,
          },
        ]
        : []),
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'BidButton',
        filter: false,

      },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'AttachmentButton',
        filter: false,

      },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'CommentsButton',
        filter: false,

      },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'ViewRFQButton',
        filter: false,

      },

      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'NotificationButton',
        filter: false,

      },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'CommentsAllButton',
        filter: false,

      },
      {
        headerName: "Participants",
        field: "vendor_count",
        width: 120,
        cellRenderer: 'ParticipantsComponent',
        filter: false,

      },
      { headerName: 'Indent ID', field: 'indent_id', width: 120, },
      { headerName: 'Status', field: 'status', width: 150 },
      { headerName: 'Source', field: 'source', width: 120 },
      {
        headerName: 'Dealer City',
        field: 'destination',
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',
        width: 150,

        valueGetter: (params) => {
          var val = (params.data && params.data.destination) ? params.data.destination : '';
          return val
            .split(',')
            .map(function (item) {
              return item
                .trim()
                .toLowerCase()
                .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
            })
            .join(', ');
        },

        cellRendererFramework: function (params) {
          const destinations = (params.value || '')
            .split(',')
            .map(function (item) { return item.trim(); })
            .filter(Boolean);

          if (!destinations.length) return '';

          const [showPopup, setShowPopup] = React.useState(false);
          const [popupPos, setPopupPos] = React.useState({ top: 0, left: 0 });
          const badgeRef = React.useRef(null);

          const firstDestination = destinations[0];
          const remainingCount = destinations.length - 1;

          const handleBadgeClick = (e) => {
            e.stopPropagation();
            if (badgeRef.current) {
              const rect = badgeRef.current.getBoundingClientRect();
              setPopupPos({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
              });
              setShowPopup(!showPopup);
            }
          };

          // Close when clicking outside
          React.useEffect(() => {
            const handleClick = (e) => {
              if (showPopup && badgeRef.current && !badgeRef.current.contains(e.target)) {
                setShowPopup(false);
              }
            };
            document.addEventListener("click", handleClick);
            return () => document.removeEventListener("click", handleClick);
          }, [showPopup]);

          return (
            <div className='flex-center-gap-6'>
              <span>{firstDestination}</span>
              {remainingCount > 0 && (
                <span
                  ref={badgeRef}
                  className="badge-blue"
                  onMouseEnter={handleBadgeClick}   // show on hover
                  onMouseLeave={() => setShowPopup(false)}  // close when mouse leaves           className="badge-blue"
                >
                  +{remainingCount}
                </span>
              )}

              {showPopup &&
                ReactDOM.createPortal(
                  <div
                    style={{
                      top: `${popupPos.top}px`,
                      left: `${popupPos.left}px`,
                    }}
                    className="popup-container-for-city"
                  >
                    {destinations.map((city, index) => (
                      <div
                        key={index}
                        className={`city-item ${index !== destinations.length - 1 ? "city-item-border" : ""}`}
                      >
                        {city}
                      </div>
                    ))}
                  </div>,
                  document.body
                )}
            </div>
          );
        }
      }, { headerName: 'Bid Start Date', field: 'bid_start_date', width: 150 },
      // { headerName: 'Material', field: 'material', width: 120 },
      { headerName: 'Truck Type', field: 'truck_type', width: 160 },
      {
        headerName: 'Total Distance (KM)',
        field: 'total_km',
        width: 120,
        valueGetter: function (params) {
          const km = params.data.total_km;

          if (km && km !== 'undefined') {
            return km;
          } else {
            return '';
          }
        }
      }, { headerName: 'Pickup Date', field: 'pickup_date', width: 120 },
      {
        headerName: 'Over Length', field: 'over_length', width: 120,
        valueGetter: function (params) {
          if (params.data.over_length == 0 || params.data.over_length == '0') {
            return 'No'
          }
          else {
            return 'Yes'
          }

        },
      },
      {
        headerName: 'Over Breadth', field: 'over_breath', width: 120, valueGetter: function (params) {
          if (params.data.over_breath == 0 || params.data.over_breath == '0') {
            return 'No'
          }
          else {
            return 'Yes'
          }

        },
      },
      // { headerName: 'Quantity', field: 'quantity' },
      // { headerName: 'Confirmed Value', field: 'confirmed_value' },
      { headerName: 'Base Price (₹)', field: 'base_price', width: 120, },

      //   { headerName: 'Participants', field: 'vendor_count' }
    ]
    const { modelForAdditionalComments, additionalComments, modelForNotifications, notificationUnread, notificationRead } = this.state;

    const { isPreviewMode, onClosePreview, rfqForm, dealers } = this.state;
    const modalStyles1 = {
      width: '300px !important'
    };

    const { rfqform, countersfortab, selectedfromdate, selectedenddate } = this.state;
    const columnDef = []
    const truck_list = [
      { value: "32 Single axle", label: "32 Single axle" },
      { value: "32 multi axle", label: "32 multi axle" },
      { value: "Trailer", label: "Trailer" },
      { value: "24 feet vehicle", label: "24 feet vehicle" },
      { value: "17 feet vehicle", label: "17 feet vehicle" },
      { value: "19 feet vehicle", label: "19 feet vehicle" },
      { value: "14 feet vehicle", label: "14 feet vehicle" },
      { value: "1MT", label: "1MT" },
    ]
    const status_list = [
      { value: "Awaiting Approval", label: "Awaiting Approval" },
      { value: "Approved", label: "Approved" },
      { value: "Rejected", label: "Rejected" },
    ];
    if (this.state.redirect) {
      return <Redirect to="/createindent" push={true} />;
    }
    var indent = this.state.selectedIndentData

    if (this.state.bidDetailsform) {
      return (
        <Redirect
          to={{
            pathname: "/biddetailsforsuperadmin",
            state: {
              selectedIndentData: this.state.selectedIndentData,
              selectedVendorQuotes: this.state.selectedVendorQuotes,
              negotiations: this.state.negotiations,
              selectedindentdata1: this.state.selectedindentdata1,
              negotiationsLogs: this.state.negotiationsLogs,
              rfqform: this.state.rfqform,
              inputTextValues: this.state.inputTextValues,
              proposedDays: this.state.proposedDays,
              selectedindent: this.state.selectedindent,
              dataforadminbifur: this.state.dataforadminbifur,
              indentfortruckdetails: this.state.indentfortruckdetails
              // onClickAcceptQuotation:this.onClickAcceptQuotation,
              // onShowdata:this.onShowdata

            }
          }}
          push={true}
        />

      );
    }
     const today = moment().format('YYYY-MM-DD');
        const oneWeekAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');
     return (
      <div className="container-fluid custom-container">
        <SweetAlert
          show={this.state.showsweetalert}
          type={this.state.basicType}
          title={this.state.basicTitle}
                    confirmBtnCssClass={`btn btn-${this.state.basicType}`}
          onConfirm={this.closeAlert}
        />
        <div className="row align-items-center justify-content-between">
          <div className="col-sm-6 mt-30p">
            <h5 className="fbold f20 mb-0">
              <span>Indent Summary</span>
            </h5>
          </div>

          <div className="col-sm-6 d-flex justify-content-end indentActionContainer">
            <>





              {/* <button
      type="button"
      className="btn float-right indentRefreshBtn"
      onClick={this.refreshindent}
    >
      <i className="icofont icofont-refresh indentIcon" />
    </button> */}
              <div
                className="custom-datepicker custom-datepicker_style"
              >
                <Datepicker
                  onDatesSelected={this.handleDatesSelected}
                  onRefreshSelected={this.refreshSelected}
                  fromDate={this.state.selectedfromdate}
                  toDate={this.state.selectedenddate}
                />
{/* 
                {(this.state.selectedfromdate || this.state.selectedenddate) && (
                  <span
                    className="clear-icon input-icon"
                    onClick={() => {
                      this.setState(
                        {
                            selectedfromdate: oneWeekAgo,
                            selectedenddate: today,
                          },
                        () => {
                          if (this.fetchInitialData) {
                            this.fetchInitialData();
                          }
                        }
                      );
                    }}

                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="none"
                      width="18"
                      height="18"
                      stroke="red"
                      strokeWidth="2"
                    >
                      <line x1="5" y1="5" x2="15" y2="15" />
                      <line x1="15" y1="5" x2="5" y2="15" />
                    </svg>
                  </span>
                )} */}
              </div>

              {/* <button
      type="button"
      className="btn btn-default float-right indentFilterBtn ml-5p"
    >
      <img
        className="mx-2 indentIcon"
        src={Filter}
        onClick={this.fetchInitialData}
        title="Filters"
      />
    </button> */}

              <button
                type="button"
                className="btn btn-default float-right indentFilterBtn ml-5p"
              >
                <img
                  className="mx-2 indentIcon"
                  onClick={() =>
                    this.setState((prev) => ({ filterToggle: !prev.filterToggle }))
                  }
                  src={Filter1}
                  title="Filters"
                />
              </button>

            </>
          </div>
        </div>

        {this.state.filterToggle && (
          <div className="filter-in">
            <div className="row d-flex justify-content-center mt-20p">
              <div className="col-xl-12 col-lg-12">
                <div className="card shadow-sm">
                  <div className="card-body card-body-custom_pd">
                    <form className="row" onSubmit={this.getindents}>
                      <div className="col-md-3 mb-3">
                        <label>Indent ID</label>
                        <Select
                          isMulti
                          id="indent_id"
                          value={
                            this.state.searchfilter.indent_id
                              ? [{ label: this.state.searchfilter.indent_id, value: this.state.searchfilter.indent_id }]
                              : []
                          }
                          onChange={(selectedOptions) =>
                            this.handleSelectChange(
                              "indent_id",
                              selectedOptions && selectedOptions.length > 0
                                ? selectedOptions[selectedOptions.length - 1]
                                : null
                            )
                          }
                          options={this.state.alldata.map(function (e) {
                            return { label: e.indent_id, value: e.indent_id };
                          })}
                          styles={customSelectStyles}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>Source</label>
                        <Select
                          isMulti
                          value={
                            this.state.searchfilter.source
                              ? [{ label: this.state.searchfilter.source, value: this.state.searchfilter.source }]
                              : []
                          }
                          onChange={(selectedOptions) =>
                            this.handleSelectChange(
                              "source",
                              selectedOptions && selectedOptions.length > 0
                                ? selectedOptions[selectedOptions.length - 1]
                                : null
                            )
                          }
                          options={[].concat(
                            Array.from(
                              new Set(
                                this.state.alldata
                                  .map(function (e) {
                                    return e.source;
                                  })
                                  .filter(function (source) {
                                    return source;
                                  })
                              )
                            ).map(function (source) {
                              return { label: source, value: source };
                            })
                          )}
                          styles={customSelectStyles}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>Status</label>
                        <Select
                          isMulti
                          value={
                            this.state.searchfilter.status
                              ? [{ label: this.state.searchfilter.status, value: this.state.searchfilter.status }]
                              : []
                          }
                          onChange={(selectedOptions) =>
                            this.handleSelectChange(
                              "status",
                              selectedOptions && selectedOptions.length > 0
                                ? selectedOptions[selectedOptions.length - 1]
                                : null
                            )
                          }
                          options={status_list}
                          styles={customSelectStyles}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>Truck Type</label>
                        <Select
                          isMulti
                          value={
                            this.state.searchfilter.type_of_truck
                              ? [
                                {
                                  label: this.state.searchfilter.type_of_truck,
                                  value: this.state.searchfilter.type_of_truck,
                                },
                              ]
                              : []
                          }
                          onChange={(selectedOptions) =>
                            this.handleSelectChange(
                              "type_of_truck",
                              selectedOptions && selectedOptions.length > 0
                                ? selectedOptions[selectedOptions.length - 1]
                                : null
                            )
                          }
                          options={this.state.truck_list}
                          styles={customSelectStyles}
                        />
                      </div>

                      <div className="col-md-12 d-flex justify-content-end">
                        <button
                          type="button"
                          onClick={this.resetSearchFilter}
                          className="btn-cancel-outline"
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn-submit-solid mr-2">
                          Search
                        </button>
                      </div>
                    </form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-md-12 col-sm-12">

            <div className="d-flex justify-content-center sub-tab-container mt-3">
              <div
                className="sub-tab border-end sub-tab-center"
                onClick={() => this.onClickparentTab('pending')}
              >
                <img src={require('../../assets/images/pendig.svg')} />
                <div
                  className={`${rfqform.pending === 'activet1' ? "fw-bold" : "font-weight500"
                    }`}
                >
                  Pending
                </div>

                <div
                  className={`f24 pending-tab-text ${rfqform.pending === 'activet1' ? "fw-bold" : "font-weight500"
                    }`}
                >
                  {countersfortab.pendingCount}
                </div>
                {rfqform.pending === 'activet1' && <div className="tab-arrow1"></div>}
              </div>
              <div
                className="sub-tab border-end"
                onClick={() => this.onClickparentTab('approved')}
              >
                <img src={require('../../assets/images/trophy.svg')} />
                <div
                  className={rfqform.approved === 'activet1' ? "fw-bold" : "font-weight500"}
                >
                  Approved
                </div>
                <div
                  className={`f24 sub-tab-count text-warning ${rfqform.approved === 'activet1' ? "fw-bold" : "font-weight500"
                    }`}
                >
                  {countersfortab.approvedcount}
                </div>
                {rfqform.approved === 'activet1' && <div className="tab-arrow1"></div>}
              </div>
              <div
                className="sub-tab border-end"
                onClick={() => this.onClickparentTab('rejected')}
              >
                <img src={require('../../assets/images/decline1.svg')} />
                <div
                  className={rfqform.rejected === 'activet1' ? "fw-bold" : "font-weight500"}
                >
                  Rejected
                </div>
                <div
                  className={`f24 sub-tab-count text-danger ${rfqform.rejected === 'activet1' ? "fw-bold" : "font-weight500"}`}
                >
                  {countersfortab.rejectedcount}
                </div>
                {rfqform.rejected === 'activet1' && <div className="tab-arrow1"></div>}
              </div>
              <div
                className="sub-tab"
                onClick={() => this.onClickparentTab('total')}
              >
                <img src={require('../../assets/images/all-inclusive.svg')} />
                <div
                  className={`sub-tab-count ${rfqform.total === 'activet1' ? "fw-bold" : "font-weight500"}`}
                >
                  All
                </div>
                <div
                  className={`f24 sub-tab-count text-success ${rfqform.total === 'activet1' ? "fw-bold" : "font-weight500"
                    }`}
                >
                  {countersfortab.totalCount}
                </div>
                {rfqform.total === 'activet1' && <div className="tab-arrow1"></div>}
              </div>
            </div>

          </div>
        </div>
        {this.state.allindents.length == 0 && (
          <div className="centered-container mt-30p">
            <h4 className='m-0px'>No Indents Found</h4>
          </div>
        )}
        {this.state.allindents.length > 0 &&
          <div className="card height-equal equal-height-lg card-equal-container">
            <div
              className="card-header flex-between"
            >
              <h5 className='m-0px'>
                <span>{this.state.selectedTab} Indents</span>
              </h5>

              <div className="flex-center-gap-10">
                <span className="float-right float-right-text">
                  <img src={require('../../assets/images/box.png')} className="icon-spacing" />
                  Materials
                  <img src={require('../../assets/images/Group 976.png')} className="icon-spacing" />
                  Bid Details
                  <img src={require('../../assets/images/downloadenable.png')} className="icon-spacing" />
                  Download File
                  <img src={require('../../assets/images/chat.png')} className="icon-spacing" />
                  Comments
                  <img src={require('../../assets/images/biddingdata.png')} className="icon-spacing" />
                  Indent Details
                  <img src={require('../../assets/images/notifications.png')} className="icon-spacing" />
                  Notifications
                  <i className="icofont icofont-history icon-spacing icon-size"></i>
                  Logs
                </span>



                <button
                  className="refresh-btn-wrapper"
                  title="Refresh"
                  onClick={this.refreshindent}
                >
                  <img src={require('../../assets/images/refreshicon.png')} alt="Refresh" className="refresh-icon" />
                </button>
              </div>
            </div>


            <div className="card-body aggridcard-body">
              <div id="myGrid" className="ag-theme-balham" style={{
                height: Math.max(250, Math.min(500, 50 + this.state.rowData.length * 40)), // 50 is header, 30 per row
                width: '100%',
                transition: 'height 0.3s ease'
              }} >
                <AgGridReact
                  rowData={this.state.rowData}
                  columnDefs={columnDefs}
                  defaultColDef={{
                    ...this.state.defaultColDef,
                    cellClass: 'ag-left-cell',
                    headerClass: 'ag-left-header'
                  }} frameworkComponents={{ CommentsAllButton, BidButton, AttachmentButton, ViewRFQButton, CancelIndentButton, NotificationButton, CommentsButton, Materialcomponent, LoadingAreaLegs, Allactionsuperadmincomponent, ParticipantsComponent, Actionforsuperadmincomponent }}
                  masterDetail={true}
                  gridOptions={{
                    context: { componentParent: this }  // ✅ THIS IS REQUIRED
                  }} detailCellRendererParams={this.state.detailCellRendererParams}
                  pagination={true}
                  paginationPageSize={100}
                  rowHeight={40}
                  headerHeight={50}
                  loadingOverlayComponentParams={{ loadingMessage: '' }}
                  onGridReady={this.onGridReady}
                // domLayout="autoHeight"
                />


              </div>
            </div>
          </div>}
        <Modal
          open={this.state.modelForAdditionalComments}
          onClose={this.onCloseModal}
          center
          classNames={{ modal: 'custom-modal-fix' }}
        >
          <div className="my-modal-wrapper">
            {/* Modal Header */}
            <div className="commentmodal-header">
              Comments
            </div>

            {/* Modal Body */}
            <div className="commentmodal-body">
              <div className="commentmodal-box">
                {this.state.additionalComments.split('\n').map((line, idx) => (
                  <div key={idx} className="commentmodal-line">{line}</div>
                ))}
              </div>
            </div>

            {/* Close Button */}
            <div className="rejectclosebtn-wrapper">
              <button className="rejectclosebtn-button" onClick={this.onCloseModal}>
                Close
              </button>
            </div>
          </div>
        </Modal>
        <div className={`slide-r ${this.state.modelForNotifications ? "slider-translate-30p" : ""} slider-right`}>
          <div className="modalheader-container">
            <div className="modalheader-row">
              <span>Notifications</span>
              <button className="modalclosebtn" onClick={this.onCloseModal}>×</button>
            </div>
          </div>

          <div className="scrollablecontainer">
            <div className="indent-id-wrapper">
              {/* <span className="indent-id-label">Indent ID</span> */}
              <span className="indent-id-value">{this.state.selectedindentfornofication}</span>
            </div>
            <hr className="indent-id-divider" />

            {(this.state.notificationUnread.length > 0 || this.state.notificationRead.length > 0) ? (
              <ul className="notification-list">
                {[...this.state.notificationUnread, ...this.state.notificationRead].map((notification, index) => {
                  const isNewIndent = notification.notification.startsWith("A New Indent");

                  return (
                    <li key={index} className="notification-item">
                      <div className="notification-header">
                        <span className="notification-title">{notification.notification_from}</span>
                        <span className="notification-date">
                          {getHyphenDDMMYYYYHHMM(notification.create_date)}
                        </span>
                      </div>
                      <div className="notification-message">
                        {notification.notification}
                      </div>

                      {isNewIndent && (
                        <div className="notification-disclaimer disclaimer-bold">
                          <span className='mr-6p'>⚠️</span>
                          DISCLAIMER: Response is mandatory
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>

            ) : (
              <p className="no-notifications">No notifications available.</p>
            )}
          </div>
        </div>
        <Modal
          open={this.state.cardforadminbifurcation}
          onClose={this.onCloseModal}
          styles={modalStyles1}
          showCloseIcon={false}
        >
          <div>
            <div className="vehicle-modal-header-updated">
              <h5 className="vehicle-modal-title-updated">
                Indent ID :&nbsp;
                {this.state.dataforadminbifur &&
                  this.state.dataforadminbifur.length > 0 &&
                  this.state.dataforadminbifur[0].indent_id
                  ? this.state.dataforadminbifur[0].indent_id
                  : "No Indent Id available"}{" "}
                &nbsp;&nbsp;&nbsp;
                Bid Price (₹):&nbsp;
                {this.state.dataforadminbifur &&
                  this.state.dataforadminbifur.length > 0 &&
                  this.state.dataforadminbifur[0].negotiatedconfirmed_price
                  ? this.state.dataforadminbifur[0].negotiatedconfirmed_price
                  : "N/A"}
              </h5>
              <button className="close-btn-updated" onClick={this.onCloseModal}>
                &times;
              </button>
            </div>

            <div>
              <table className="vehicle-table-updated">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Dealer Name</th>
                    <th>Dealer City</th>
                    <th>Dealer State</th>
                    <th>Dealer Pincode</th>
                    <th>Material</th>
                    <th>Bid Price (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.dataforadminbifur.length > 0 ? (
                    this.state.dataforadminbifur.map((destination, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{destination.dealer_name || "N/A"}</td>
                        <td>{destination.dealer_city || "N/A"}</td>
                        <td>{destination.dealer_state || "N/A"}</td>
                        <td>{destination.dealer_pincode || "N/A"}</td>
                        <td>
                          {destination.materials &&
                            destination.materials.length > 0
                            ? destination.materials
                              .map((mat) => mat.material_type)
                              .join(", ")
                            : "N/A"}
                        </td>
                        <td>
                          <input
                            type="text"
                            placeholder="Enter Bid Price"
                            value={destination.bid_price || ""}
                            onChange={(e) =>
                              this.handleInputChangeforadmin_bifur(
                                index,
                                "bid_price",
                                e.target.value
                              )
                            }
                            className="bid-input-field"
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">No destinations available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="float-right-box">
              <button
                type="button"
                className="btn btn-success"
                onClick={this.onSubmitdataforadminbifurcation}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal>

        <div
          className={
            "slide-r " +
            (this.state.showsliderforbid ? "slider-translate-30p" : "") +
            " slider-right"
          }
        >                <h3 className="subH"> Place Bid
            <span
              className="float-right closebtn"
              onClick={this.onCloseSlider}
            >
              X
            </span>
          </h3>
          <div className="slide-r-body relative-container">
            <div className="container-fluid">
              <form className="theme-form" onSubmit={this.onSubmitquote}>
                <div className="form-group">
                  <label>Bid Price (₹)</label>
                  <input
                    type="text"
                    value={this.state.selected_bid_price}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        this.handleBidPriceChange(value);
                      }
                    }}
                    className="form-control"
                    placeholder="Enter Bid Price"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Transit Days</label>
                  <input
                    type="text"
                    value={this.state.selected_transit_days}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        this.handleTransitDaysChange(value);
                      }
                    }}
                    className="form-control"
                    placeholder="Enter Transit Days"
                    required
                  />
                </div>
                <div className="form-group2 align-self-end">
                  <button type="submit" className="btn btn-success">Quote</button>
                </div>
              </form>

            </div>
          </div>
        </div>
        <div className={
          "slide-r " +
          (this.state.showBidDetailsSlider ? "slider-translate-90p" : "") +
          " slider-right"
        }>


        </div>

        <Modal open={this.state.isPreviewMode} onClose={() => this.setState({ isPreviewMode: false })}>
          <RFQView rfqForm={rfqForm} dealers={dealers} />
        </Modal>
        {this.state.rejectModel && (
          <div className="rejectmodal-overlay">
            <div className="rejectmodal-content">

              {/* Close Button Top-Right */}
              <button className="rejectmodal-close-btn" onClick={this.onCloseModal}>×</button>

              {/* Red Pin Icon */}
              <div className="rejectmodal-icon">
                <div className="rejectmodal-circle">
                  <span className="rejectmodal-cross">×</span>
                </div>
                <div className="rejectmodal-stick"></div>
              </div>

              {/* Title & Description */}
              <div className="rejectmodal-text">
                <h5>Are you sure you want to reject ?</h5>
                <p>
                  Once you do this, it can’t be undone <br />
                  you won’t be able to take it back.
                </p>
              </div>

              {/* Textarea */}
              <div className="rejectmodal-body">
                <label>Tell us why you’re rejecting it: <span className="text-danger">*</span></label>
                <textarea
                  className="rejectmodal-textarea"
                  placeholder="Type the reason here..."
                  value={this.state.approval1RejectionReason}
                  onChange={(e) => this.setState({ approval1RejectionReason: e.target.value })}
                ></textarea>
              </div>

              {/* Reject Button */}
              <div className="reject-btn-container">
                <button className="text-link-reject-btn" onClick={this.onclickreject}>
                  Reject
                </button>
              </div>



            </div>
          </div>
        )}
        <div className={"dataLoadpage " + (this.state.loadshow)}>
        </div>
        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
          <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
        </div>
        <div className={"overlay " + (this.state.overlay)} onClick={this.onClickHideall}></div>
      </div>
    );
  }

  // More methods coming in next chunks...
}

export default IndentAuctionComponent2;


